// Framing a photo in the avatar maker's circle (controllers/avatar_maker_controller.js): where the photo sits and how
// big, kept so the circle is always covered. A frame is the photo's size (w, h), the circle's width on screen (d), the
// point of the photo at the circle's middle (x, y) and the zoom over just covering it (zoom, 1 to MAX_ZOOM).
export const MAX_ZOOM = 4

// Pixels on screen to one of the photo's.
export const scale = (f) => (f.d / Math.min(f.w, f.h)) * f.zoom

// Kept where the circle stays inside the photo.
export function clamp(f) {
  const zoom = Math.min(MAX_ZOOM, Math.max(1, f.zoom))
  const r = f.d / 2 / scale({ ...f, zoom })
  const within = (v, size) => Math.min(size - r, Math.max(r, v))
  return { ...f, zoom, x: within(f.x, f.w), y: within(f.y, f.h) }
}

// The photo just covering the circle, its middle at the circle's.
export const start = (w, h, d) => clamp({ w, h, d, x: w / 2, y: h / 2, zoom: 1 })

// Dragged by (dx, dy) screen pixels: the photo follows the pointer.
export function move(f, dx, dy) {
  const s = scale(f)
  return clamp({ ...f, x: f.x - dx / s, y: f.y - dy / s })
}

export const zoomTo = (f, zoom) => clamp({ ...f, zoom })

// The circle's square in the photo's pixels, to cut out: [left, top, side].
export function cut(f) {
  const side = f.d / scale(f)
  return [f.x - side / 2, f.y - side / 2, side]
}

// Where the photo is drawn on a stage `size` wide with the circle in its middle: [left, top, width, height].
export function placed(f, size) {
  const s = scale(f)
  return [size / 2 - f.x * s, size / 2 - f.y * s, f.w * s, f.h * s]
}
